import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useTextColor = (colors: { color: string, label: string }[]) => {
    const makFabric = useSelector((state: any) => state.makFabric)

    const [textC, setTextC] = useState({
        color: "#000000",
        label: "Black",
    })

    useEffect(() => {
        if (makFabric) {
            const selectedColor = colors.find(item => item.color === makFabric.getSelectedText());
            selectedColor && makFabric.getSelectedText() &&
                setTextC(selectedColor)
        }
    }, [makFabric])

    const handleSelectColor = useCallback(({ color, label }) => {
        makFabric.setTextColor(
            makFabric.getSelectedText(),
            color
        )
        setTextC({ color, label })

    },
        [makFabric],
    )

    return {
        color: textC,
        changeColor: handleSelectColor
    }

}